// @ts-nocheck
import getColor from "@insite/mobius/utilities/getColor";
import { transitionHoverStyles } from "@store/Themes/common/mixins/transition";
import { buttonResetProps } from "@store/Themes/common/props/button";
import { focusUpdateStyles } from "@toolkit/Themes/common/mixins/common";
import { css } from "styled-components";

export const productCompareRemoveButtonStyles = () => css`
    ${buttonResetProps.css}
    ${focusUpdateStyles(true)}
    transition: ${transitionHoverStyles("color")};

    &:hover {
        color: ${getColor("primary")};
    }
`;
